import React, { Suspense } from 'react';

// Routes
import { Navigate, Route } from 'design/router';

// Components
import { Spinner } from 'design/components';

// Catalog
import { GROUP, TYPES } from '@/views/experiments/music-visualiser/catalog';

// Types
import { Types } from './types';

// Constants
import { PARAMS, toPath } from '@/views/experiments/music-visualiser/constants';

const Contents = React.lazy(async () => {
  const { Contents } = await import('./contents');

  return { default: Contents };
});

const Lazy: React.FunctionComponent = () => (
  <Suspense fallback={<Spinner position='inline' />}>
    <Contents />
  </Suspense>
);

/** `/:group` - the station; its index goes to its first type. */
const Groups = (
  <Route path={`:${PARAMS.group}`} element={<Lazy />}>
    <Route
      index
      element={
        <Navigate to={toPath({ group: GROUP, type: TYPES[0] })} replace />
      }
    />
    {Types}
  </Route>
);

export { Groups };
